// URL extraction and annotation utilities for Generate Rationale tab

// Extract URLs from text, deduplicated
export function extractUrls(text) {
  const urlRegex = /https?:\/\/[^\s)>\]"']+/g;
  const matches = text.match(urlRegex) || [];
  return [...new Set(matches)];
}

// Annotate rationale text with validation badges inline
export function annotateUrlsWithBadges(text, validationResults) {
  if (!validationResults || !validationResults.length) return text;
  const resultMap = {};
  validationResults.forEach((r) => { resultMap[r.url] = r; });

  let annotated = text;
  for (const [url, result] of Object.entries(resultMap)) {
    let badge;
    if (result.valid) {
      badge = ' ✅';
    } else if (result.redirectUrl) {
      badge = ` ↗️ (redirects to ${result.redirectUrl})`;
    } else {
      badge = ` ❌ (HTTP ${result.statusCode || 'timeout'})`;
    }
    annotated = annotated.split(url).join(url + badge);
  }
  return annotated;
}
